export var DESKTOP_COLUMN_COUNT = 5;
export var TABLET_COLUMN_COUNT = 4;
export var MOBILE_COLUMN_COUNT = 2;
var ASPECT_RATIO_VERTICAL_UPPER_THRESHOLD = 0.8;
var ASPECT_RATIO_SQUARE_UPPER_THRESHOLD = 1.1;
export var getVideoAspectRatio = function(videoDimensions) {
    if (videoDimensions && videoDimensions.height > 0) {
        return videoDimensions.width / videoDimensions.height;
    }
    return 1.6;
};
export var determineVideoGridPositioning = function(param) {
    var $tileCount = param.$tileCount, $columnCount = param.$columnCount, $videoDimensions = param.$videoDimensions;
    var aspectRatio = getVideoAspectRatio($videoDimensions);
    if ($columnCount === MOBILE_COLUMN_COUNT) {
        if (aspectRatio < ASPECT_RATIO_VERTICAL_UPPER_THRESHOLD) {
            return {
                gridColumn: "1 / span 2",
                gridRow: "3 / span 2"
            };
        } else {
            return {
                gridColumn: "1 / span 2",
                gridRow: "3"
            };
        }
    }
    if (($columnCount === DESKTOP_COLUMN_COUNT || $columnCount === TABLET_COLUMN_COUNT) && $tileCount <= 10) {
        if (aspectRatio < ASPECT_RATIO_VERTICAL_UPPER_THRESHOLD) {
            return {
                gridColumn: "1 / span 2",
                gridRow: "2 / span 2"
            };
        } else if (aspectRatio < ASPECT_RATIO_SQUARE_UPPER_THRESHOLD) {
            return {
                gridColumn: "1 / span 2",
                gridRow: "2"
            };
        } else {
            return {
                gridColumn: "1 / span 3",
                gridRow: "2"
            };
        }
    }
    if (aspectRatio < ASPECT_RATIO_VERTICAL_UPPER_THRESHOLD) {
        return {
            gridColumn: "1 / span 2",
            gridRow: "3 / span 2"
        };
    } else if (aspectRatio < ASPECT_RATIO_SQUARE_UPPER_THRESHOLD) {
        return {
            gridColumn: "1 / span 2",
            gridRow: "3"
        };
    } else {
        return {
            gridColumn: "1 / span 3",
            gridRow: "3"
        };
    }
};
